import Text from '~/common/components/Texts/Text';
import { useSelectedAlert } from '~/stores/navigationStore';

import ClassifyDynamicFormContent from './ClassifyDynamicFormContent';
import ClassifyHideDocsModal from './ClassifyHideDocsModal';
import ClassifyStaticFormContent from './ClassifyStaticFormContent';
import { StyledClassifyFormContentContainer } from './StyledComponents/ClassifyFormContent.styles';
import { type ClassifyFormData, withForm } from './hooks/ClassifyFormHook';

const ClassifyFormContent = withForm({
  defaultValues: {} as ClassifyFormData,
  render: function ClassifyFormContent({ form }) {
    return (
      <StyledClassifyFormContentContainer as="section">
        <Text fontSize="sm" sx={{ mb: 6 }} id="formInstructions">
          {useSelectedAlert().displayTitleDesc}
        </Text>
        <ClassifyStaticFormContent form={form} />
        <ClassifyDynamicFormContent form={form} />

        <ClassifyHideDocsModal />
      </StyledClassifyFormContentContainer>
    );
  },
});

export default ClassifyFormContent;
